module.exports = __webpack_public_path__ + "img/8.314da4b2.png";